import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { BrandingService } from '@library/common';
import {
   BrowserCheckService,
   BreakpointService,
   // ErrorMessageService,
   EnvironmentService,
   TextService,
   PrefetchService,
   GoogleAnalyticsService,
   MaintenanceService,
   PortalService,
} from '@library/core/services';

import * as FullStory from '@fullstory/browser';

import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent {
   constructor(
      public router: Router,
      public brand: BrandingService,
      private e: EnvironmentService,
      private gtag: GoogleAnalyticsService,
      private check: BrowserCheckService,
      private breakpoints: BreakpointService,
      private text: TextService,
      private prefetch: PrefetchService,
      private maintenance: MaintenanceService,
      private portalService: PortalService,
   ) {
      this.portalService.current = 'vendor';

      this.e.environment = environment;
      this.gtag.load( environment?.gtagId );
      this.breakpoints.tap();
      this.check.check();
      this.maintenance.check();
      FullStory.init({ orgId: 'o-1MB0F2-na1', devMode: !environment.production });
      // console.log( 'requesting server', this.server );

      this.text.loginTitle = `Welcome to Our Vendor Portal`;
      this.text.loginSubTitle = `The Radiant Vendor Portal provides access to vital information
         on all your shipments and has been designed to streamline the transportation vendor workflow.
         Log in today to manage shipment details.`;

      this.prefetch.items = [ 'currencies' ];
   }
}
